import { render, staticRenderFns } from "./assetslist.vue?vue&type=template&id=2853e55f&scoped=true"
import script from "./assetslist.js?vue&type=script&lang=js&external"
export * from "./assetslist.js?vue&type=script&lang=js&external"
import style0 from "./assetslist.vue?vue&type=style&index=0&id=2853e55f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2853e55f",
  null
  
)

export default component.exports